/**
 * FICHIER CONFIG TEMPLATE
 * 
 * Ce fichier définit les métadonnées du composant pour le système de grille.
 * 
 * Champs obligatoires :
 * - name : Nom technique du composant (doit correspondre à la clé dans componentRegistry)
 * - displayName : Nom affiché dans l'interface
 * - description : Description du composant
 * - category : Catégorie (UI, Navigation, Layout, etc.)
 * - defaultParams : Valeurs par défaut des paramètres
 * - paramDefinitions : Définition de chaque paramètre avec son type
 * - outsideGrid : true si le composant doit être hors grille (ex: navbar)
 * - defaultEnabled : true si le composant est activé par défaut
 */

import type { ComponentMetadata } from '../../G&CSCM/Core/types';

export interface TemplateComponentParams {
    title: string;
    backgroundColor: string;
    fontSize: number;
    showBorder: boolean;
}

export const TemplateComponentConfig: ComponentMetadata = {
    name: 'TemplateComponent',
    displayName: '📦 Template (Exemple)',
    description: 'Composant template montrant les bonnes pratiques de développement',
    category: 'Exemples',
    
    // Valeurs par défaut (utilisées quand on ajoute le composant)
    defaultParams: {
        title: 'Template',
        backgroundColor: 'rgba(0, 123, 255, 0.1)',
        fontSize: 14,
        showBorder: true
    },
    
    // Définitions des paramètres (types, labels, descriptions)
    paramDefinitions: {
        title: {
            type: 'string',
            label: 'Titre',
            description: 'Titre affiché en haut du composant'
        },
        backgroundColor: {
            type: 'string',
            label: 'Couleur de fond',
            description: 'Couleur de fond (format rgba ou hex)'
        },
        fontSize: {
            type: 'number',
            label: 'Taille police',
            description: 'Taille de la police en pixels'
        },
        showBorder: {
            type: 'boolean',
            label: 'Afficher bordure',
            description: 'Affiche une bordure autour du composant'
        }
    },
    
    outsideGrid: false, // Ce composant va dans la grille
    defaultEnabled: true
};

export default TemplateComponentConfig;

